import React, { useEffect } from 'react';
import { usePlacesWidget } from "react-google-autocomplete";
import CommonInput from '../CommonInput';
 
const MapInput = ({ label, handleInputChange,value,placeholder="Location" }) => {
  const { ref } = usePlacesWidget({
    apiKey: "AIzaSyCkssBEyF60HLE5idQB9m5i407InVjjt-0",
    onPlaceSelected: (place) => {
      handleInputChange(place); 
    },
    options: {
      types: ['geocode'], 
      componentRestrictions: { country: 'in' },
    },
  });
 
  return (
    <div className="anvCustom_floatInput form-floating">
      <input
        id={label}
        className="form-control"
        placeholder={placeholder}
        autoComplete='off'
        ref={ref} 
        value={value} // Set the value programmatically
        onChange={(e) => handleInputChange({ formatted_address: e.target.value })}
      />
      <label htmlFor={label}>
        <span>{label}</span>
      </label>
    </div>
  );
};
 
export default MapInput;